<!-- Breadcrumb -->
<ol class="breadcrumb">
  <li class="breadcrumb-item">
    <a routerLink="">Início</a>
  </li>
  <li class="breadcrumb-item">Minha Conta</li>
  <li class="breadcrumb-item active">
    Meus Bilhetes
  </li>
</ol>
<!-- //.Breadcrumb -->

<h2 class="titulo-interna">Histórico de Bilhetes</h2>



  <div class="tab-page">

    <ngb-tabset #t="ngbTabset">

    <!-- Tab Mensal -->
    <ngb-tab id="mensal">


      <ng-template ngbTabTitle>
        <div class="tab-title">Mensal</div>
      </ng-template>
      <ng-template ngbTabContent>

        <form autocomplete="off" [formGroup]="bilheteMensalConsumidorForm">
          <div class="form-row">
            <div class="form-group col-md-3">
              <br>
              <label for="mes">Mês</label>
              <select class="form-control" formControlName="mes">
                <option>Selecione...</option>
                <option *ngFor="let mes of meses" [value]="mes.valor">{{mes.nome}}</option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <br>
              <label for="ano">Ano</label>
              <select class="form-control" formControlName="ano">
                <option>Selecione...</option>
                <option *ngFor="let ano of anos" [value]="ano">{{ano}}</option>
              </select>
            </div>

          </div>
          <div class="form-group col-md-3">
            <button class="btn btn-bluelight" data-toggle="tooltip" data-placement="top" title="Pesquisar" (click)="pesquisarMensal()">Pesquisar</button>
          </div>
        </form>
        <br>
        <br>

        <div class="row" *ngIf="MensagemErroGeralMensal">
          <div class="alert alert-danger col-sm-12">
              <span>{{MensagemErroGeralMensal}}</span>
          </div>
      </div>

    <div *ngIf="!MensagemErroGeralMensal">

        <div class="row" *ngIf="quantidadeBilhetesAtualConsumidorMensal >= 0 && nomeSorteioMensal">
            <div class="alert alert-primary col-sm-12">
                 <span>Sorteio: {{ nomeSorteioMensal }} <span *ngIf="!ahPrevisaoMensal"> - Total de Bilhetes {{ totalBilhetesMensal }}. </span> </span>
            </div>
       </div>

       <div class="row" *ngIf="consumidorImpedidoMensal">
            <div class="alert alert-danger col-sm-12">
                <span>Você não participa/participou, mesmo possuindo bilhetes, pois está/estava impedido na Campanha NPB na data de realização do Sorteio.</span>
            </div>
      </div>

        <div class="row " *ngIf="quantidadeBilhetesAtualConsumidorMensal === 0 && ahPrevisaoMensal && bilhetesGeradosMensal == false">
          <div class="alert alert-primary col-sm-12">
              Os bilhetes referentes ao mês atual serão gerados no início do mês subsequente.
                        <br>
              <span > Você tem até o momento o total de {{ QuantidadePrevisaoBilhetesMensal }} bilhetes para esse sorteio.</span>
          </div>
        </div>

        <div class="row" *ngIf="quantidadeBilhetesAtualConsumidorMensal > 0 && bilhetesMensal && bilhetesMensal.length > 0">
          <table class="table table-striped" aria-describedby="Listagem Bilhetes cidadão">
            <thead>
              <tr>
                <th>Bilhete</th>
                <th>Nº do Sorteio</th>
                <th>Situação</th>
                <th>Data de Realização</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let bilhete of bilhetesMensal; let i = index">
                <td>{{ bilhete.num_bilhete_consumidor }}</td>
                <td>{{ bilhete.num_sorteio_premiacao_consumidor }}</td>
                <td>{{ bilhete.des_situacao_sorteio_premiacao_consumidor }}</td>
                <td>
                  {{ bilhete.dtc_realizacao_sorteiro_premiacao_consumidor | date:'dd/MM/yyyy' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

          <div class="card-block" *ngIf="bilhetesMensal && bilhetesMensal.length > 0">
            <ngb-pagination
                  [collectionSize]="totalBilhetesMensal"
                  [(page)]="paginaMensal"
                  [pageSize]="tamanhoPaginaMensal"
                  [maxSize]="5"
                  [rotate]="true"
                  [ellipses]="true"
                  [boundaryLinks]="true"
                  (pageChange)="pageChangeMensal($event)"
                  class="d-flex justify-content-end"></ngb-pagination>
          </div>

      </div>

</ng-template>
</ngb-tab>
<!-- //.Tab Mensal -->

    <!-- Tab Especial -->
    <ngb-tab id="especial">

      <ng-template ngbTabTitle>
        <div class="tab-title">Especial</div>
      </ng-template>
      <ng-template ngbTabContent>

        <br/>
        
    
        <form autocomplete="off" [formGroup]="bilheteEspecialConsumidorForm">
          <div class="form-row">
            <div class="form-group col-md-8">
              <br>
              <label for="sorteioEspecial">Sorteio Especial:</label>
              <select name="seqSorteio" id="seqSorteio" class="form-control" title="Selecione o sorteio." formControlName="sorteioEspecial">
                  <option value="null">Selecione</option>
                   <option *ngFor="let Sorteio of sortByDesc()" [value]="Sorteio.seqSorteio">{{Sorteio.numeroSorteio+ ' - ' + Sorteio.descricao }}</option>
              </select>
            </div>

          </div>
          <div class="form-group col-md-3">
            <button class="btn btn-bluelight" data-toggle="tooltip" data-placement="top" title="Pesquisar" (click)="pesquisarEspecial()">Pesquisar</button>
          </div>

        </form>

        <div class="row" *ngIf="MensagemErroGeralEspecial">
          <div class="alert alert-danger col-sm-12">
              <span>{{MensagemErroGeralEspecial}}</span>
          </div>
      </div>

        <br>

        <div *ngIf="!MensagemErroGeralEspecial">

        <div class="row" *ngIf="consumidorImpedidoEspecial && total_geral_bilhetes > 0">
          <div class="alert alert-danger col-sm-12">
              <span>Você não participa/participou, mesmo possuindo bilhetes, pois está/estava impedido na Campanha NPB na data de realização do Sorteio.</span>
          </div>
        </div>

          <div class="row" *ngIf="listaAgrupamentoMensalBilhete.length > 0">

            <p><b>Situação:</b> {{descricaoSituacaoSorteioEspecial}}	 &nbsp;&nbsp;<b>Data da Realização:</b> {{dataSorteioEspecial | date: 'dd/MM/yyyy' }}</p>
            <table class="table table-hover table-bordered table-responsive-xl" aria-describedby="Listagem Bilhetes cidadão">
              <thead>
                <th>Mês</th>
                <th>Ano</th>
                <th>Total Bilhetes</th>
                <th>Ação</th>
              </thead>

              <tbody>

            <ng-container *ngFor="let registro of listaAgrupamentoMensalBilhete; let i = index">
              <tr>
                <td class="col-md-1">{{ registro.descricao_mes ? registro.descricao_mes.charAt(0).toUpperCase() + registro.descricao_mes.substr(1).toLowerCase() : '' }}</td>
                <td class="col-md-1">{{ registro.ano }}</td>
                <td class="col-md-1">{{ registro.total_bilhetes}}</td>

                <td class="col-md-10">
                  <button *ngIf="(registro.flagMostrarBilhetes === false) && (registro.total_bilhetes > 0 )" class="btn btn-primary" type="button"  data-placement="top"
                      (click)="registro.flagMostrarBilhetes = true; pesquisarDetalhe(registro.ano, registro.mes);">
                      <i class="fa fa-eye"></i> Ver Bilhetes
                  </button>
                  <button *ngIf="(registro.flagMostrarBilhetes === true) && (registro.total_bilhetes > 0 )" class="btn btn-primary" type="button"  data-placement="top"
                    (click)="registro.flagMostrarBilhetes = false; this.listaDetalheAgrupamentoMensalBilhete = [];">
                    <i class="fa fa-eye-slash"></i>
                  </button>

                  <ng-container>
                    <ul *ngIf="registro.flagMostrarBilhetes === true" style="column-count: 3">
                      <li class="badge badge-primary badge-pill" *ngFor="let item of this.listaDetalheAgrupamentoMensalBilhete">{{item.num_bilhete_consumidor}}</li>
                    </ul>
                  </ng-container>
                </td>
              </tr>

            </ng-container>
              </tbody>
              <tfoot>
                <td class="col-md-1"><b>Total:</b> </td>
                <td class="col-md-1"></td>
                <td class="col-md-2"><b>{{ total_geral_bilhetes }}</b></td>
              </tfoot>
            </table>
          </div>

          <div class="row " *ngIf="total_geral_bilhetes === 0">
            <div class="alert alert-danger col-sm-12">
                Nenhum Bilhete foi encontrado para o sorteio selecionado.
            </div>
          </div>

        </div>
</ng-template>
</ngb-tab>
<!-- //.Tab Especial -->

  </ngb-tabset>

</div>



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-bilhetes/consumidor-bilhetes.component.html